import { useState } from 'react'
import Image from 'next/image'
import { Card, Placeholder, Text } from 'rsuite'
import useTranslation from '@/hooks/useTranslation'
import styles from './modelTypes.module.scss'

const ModelTypeCard = ({ modelType, imageUrl, modelTypeTitle, onClickTrim, ariaLabel }) => {
  const [imageLoaded, setImageLoaded] = useState(false)
  const t = useTranslation()

  return (
    <Card
      key={modelType}
      onClick={onClickTrim}
      title={modelTypeTitle}
      className={styles.modelTypesCard}
      tabIndex={0}
      role="button"
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClickTrim()
        }
      }}
      aria-label={
        ariaLabel ||
        t('modelTypes_select_trim', 'Select trim {{trim}} to view vehicle resources', {
          trim: modelTypeTitle
        })
      }
    >
      <div className={styles.modelTypesCardImageWrapper}>
        {imageUrl ? (
          <>
            {!imageLoaded && <Placeholder.Graph height={138} className={styles.modelTypesCardPlaceholder} active />}
            <Image
              src={imageUrl}
              alt=""
              fill
              className={styles.modelTypesCardImage}
              style={{ objectFit: 'cover', opacity: imageLoaded ? 1 : 0 }}
              onLoad={() => setImageLoaded(true)}
            />
          </>
        ) : (
          <Placeholder.Graph height={138} className={styles.modelTypesCardPlaceholder} />
        )}
      </div>
      <Text className={styles.modelTypesCardTitle}>{modelTypeTitle}</Text>
    </Card>
  )
}

export default ModelTypeCard
